import React from 'react';
import { Field } from 'redux-form';
import { renderTextField, renderNumberField, requiredValidator, renderDatePicker, renderSelect } from 'utils/formHelper';

const INDUSTRIES = ["Accommodation - B&B, Hotel, Motel", "Accounting", "Adult Related Indstries", "Advertising Agencies", "Aged Residential Care", "Architects", "Auction Houses", "Book Retailing", "Building Pest Control", "Building and Other Industrial Cleaning", "Cafes and Restaurants", "Catering Services", "Chemists and Pharmacies", "Commercial Contractors", "Courier Pick Up and Delivery", "Dental Services", "Direct Marketing", "Electrical Services", "Employment, Recruitment and Labour Hire", "Engineering Design and Consulting", "Equipment Hire", "Event and Entertainment Sales", "Financial Broking Services", "Fire and Security Alarm", "Firearm Dealers", "Floor Coverings Retailing", "Flower Retailing", "Freight Forwarders and Customs Cleaning Houses", "Fruit and Vegetable Retailing", "Garden Supplies and Retailing", "Gardening and Landscape Services", "General Medical Practitioners and Specialists", "Glass Tinting", "Glaziers", "Hairdressing and Beauty Services", "Hardware and Building Supplies", "Health/Fitness Centres and Gyms", "Housewares Retailing", "Installation Services", "Legal Services", "Liquor Retailing", "Marine Equipment Retailing", "Motor Mechanics and Workshops", "Newsagencies", "Optometry and Optical Services", "Other Building Installation Services", "Other General Services", "Painting and Decorating Services", "Panel-beaters and Smash Repairers", "Pathology and Diagnostic Imaging", "Petrol Stations", "Physiotheraphy, Chiropratic and Oesteopathic Services", "Plumbing Services", "Professional Photography", "Property Developers", "Pubs, Taverns and Bars", "Real Estate Services", "Residential and Commercial Property Operators", "Solar, Heating, Ventilation and Air Condition Services", "Sports and Physical Education and Instruction", "Supermarkets", "Takeaway Food", "Taxi and Hire Cars", "Towing Services", "Transport and Haulage", "Travel Agencies", "Used Vehicle Dealerships", "Veterinary Services", "Watch and Jewellery Retailing", "Wheel and Tyre Sales"]

export default class CustomerDetails extends React.Component {
  render = () => {
    return (
      <div>
        <Field
          name='businessName'
          component={renderTextField}
          label='Business Name'
          validate={requiredValidator}
        />
        <Field
          name='name'
          component={renderTextField}
          label='Name'
          validate={requiredValidator}
        />
        <Field
          name='contactEmail'
          component={renderTextField}
          label='Email'
          validate={requiredValidator}
        />
        <Field
          name='contactNumber'
          component={renderTextField}
          label='Mobile'
          validate={requiredValidator}
        />
        <Field
          name='industry'
          component={renderSelect}
          label='Industry'
          options={INDUSTRIES}
          validate={requiredValidator}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Leads/CustomerDetails.js